/* index.tsx generated by @compiled/babel-plugin v3.0.2 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0bjKvDOLYo%7Bborder-radius%3Ainherit%7D%0A._4bt5LAnQyn%7Boverflow-x%3Ahidden%7D%0A._2WAcuGnQyn%7Boverflow-y%3Ahidden%7D%0A._3iDTPbQ4SZ%7Bdisplay%3Aflex%7D%0A._39xV02N91d%7Bwidth%3A100%25%7D%0A._4kiQYAgs9g%7Bmin-height%3A420px%7D%0A._1mT5xdRAKS%7Bposition%3Arelative%7D%0A._2O5Vij7dHp%7Bflex-grow%3A1%7D%0A._3YEZNO7dHp%7Bflex-shrink%3A1%7D%0A._1bHrqE715P%7Bflex-basis%3A50%25%7D%0A._0aFT5vbt8w%7Bflex-direction%3Acolumn%7D%0A._4ouGXIdnbC%7Bmin-width%3A0%7D%0A._4kiQYAdnbC%7Bmin-height%3A0%7D%0A._46hvQmS40j%7Bpadding-block-start%3Avar(--ds-space-500%2C40px)%7D%0A._0xmtkoNHnM%7Bpadding-block-end%3Avar(--ds-space-300%2C24px)%7D%0A._0LQT5ES40j%7Bpadding-inline-start%3Avar(--ds-space-500%2C40px)%7D%0A._03SyCPS40j%7Bpadding-inline-end%3Avar(--ds-space-500%2C40px)%7D%0A._0KLXruqi9L%7Bbackground-color%3Avar(--ds-surface-raised%2C%23fff)%7D%0A._2O5VijdnbC%7Bflex-grow%3A0%7D%0A._3YEZNOdnbC%7Bflex-shrink%3A0%7D%0A._1bHrqEIZbP%7Bflex-basis%3Aauto%7D%0A._39xV02vmfA%7Bwidth%3A133px%7D%0A._46hvQmNHnM%7Bpadding-block-start%3Avar(--ds-space-300%2C24px)%7D%0A._1UtDYzKGUX%7Bcolor%3Avar(--ds-text-subtlest%2C%236b6e76)%7D%0A._0hPCNLFlnN%7Balign-items%3Astretch%7D%0A._37wbyuFlnN%7Bjustify-content%3Astretch%7D%0A._0mcu6jOLYo%7Bborder-start-end-radius%3Ainherit%7D%0A._3kIZMxOLYo%7Bborder-end-end-radius%3Ainherit%7D%0A._0KLXrunmFW%7Bbackground-color%3Avar(--ds-surface-sunken%2C%23f8f8f8)%7D%0A._1mT5xdWVPG%7Bposition%3Aabsolute%7D%0A._2I62gz5zaO%7Binset-block-start%3Avar(--ds-space-200%2C1pc)%7D%0A._1OKFqY5zaO%7Binset-inline-end%3Avar(--ds-space-200%2C1pc)%7D%0A._42Yu6B7dHp%7Bz-index%3A1%7D%0A._37wbyuz9WS%7Bjustify-content%3Aflex-end%7D%0A._0jFU0VN91d%7Bheight%3A100%25%7D%0A._00EA0eiObl%7B-o-object-fit%3Acover%3Bobject-fit%3Acover%7D%0A._3iDTPbvLZJ%7Bdisplay%3Ablock%7D");




































import React, { useCallback, useState } from 'react';
import Button from '@atlaskit/button/default/button';
import Heading from '@atlaskit/heading/heading';
import Image from '@atlaskit/image/image';
import { CloseButton } from '@atlaskit/modal-dialog/close-button';
import Modal from '@atlaskit/modal-dialog/modal-dialog';
import ModalTransition from '@atlaskit/modal-dialog/modal-transition';
import { Box } from '@atlaskit/primitives/compiled/box';
import { Stack } from '@atlaskit/primitives/compiled/stack';
import { Hide } from '@atlaskit/primitives/responsive/hide';
import { FormattedMessage } from 'react-intl';
import { useRovoAppification } from '@townsquare/rovo/appification';
import { HomeScreenSpaceFlagsChangeBoarding } from '../../placements';
import headerDark from './assets/header-dark.svg';
import headerLight from './assets/header-light.svg';
import illustrationDark from './assets/illustration-dark.svg';
import illustrationLight from './assets/illustration-light.svg';
const styles = {
  modalContainer: "_0bjKvDOLYo _4bt5LAnQyn _2WAcuGnQyn _3iDTPbQ4SZ _39xV02N91d _4kiQYAgs9g _1mT5xdRAKS",
  leftHalf: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqE715P _3iDTPbQ4SZ _0aFT5vbt8w _4ouGXIdnbC _4kiQYAdnbC _46hvQmS40j _0xmtkoNHnM _0LQT5ES40j _03SyCPS40j _0KLXruqi9L",
  headerImage: "_2O5VijdnbC _3YEZNOdnbC _1bHrqEIZbP _39xV02vmfA",
  content: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEIZbP _46hvQmNHnM",
  bodyText: "_1UtDYzKGUX",
  rightHalf: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqE715P _4bt5LAnQyn _2WAcuGnQyn _3iDTPbQ4SZ _0hPCNLFlnN _37wbyuFlnN _4ouGXIdnbC _1mT5xdRAKS _0mcu6jOLYo _3kIZMxOLYo _0KLXrunmFW",
  closeButton: "_1mT5xdWVPG _2I62gz5zaO _1OKFqY5zaO _42Yu6B7dHp",
  footer: "_2O5VijdnbC _3YEZNOdnbC _1bHrqEIZbP _3iDTPbQ4SZ _37wbyuz9WS _46hvQmNHnM",
  illustration: "_39xV02N91d _0jFU0VN91d _00EA0eiObl _3iDTPbvLZJ"
};
type RovoAppificationModalProps = {
  dismiss: () => void;
};
function RovoAppificationModal({
  dismiss
}: RovoAppificationModalProps): React.JSX.Element {
  const [isOpen, setIsOpen] = useState(true);
  const onClose = useCallback(() => {
    setIsOpen(false);
    dismiss();
  }, [dismiss]);
  return <ModalTransition>
			{isOpen && <Modal onClose={onClose} width="large" testId="rovo-appification-modal">
					<Box xcss={styles.modalContainer}>
						<Box xcss={styles.closeButton}>
							<CloseButton onClick={onClose} label="Close modal" />
						</Box>
						<Box xcss={styles.leftHalf}>
							<Box xcss={styles.headerImage}>
								<Image src={headerLight} srcDark={headerDark} alt="" testId="rovo-appification-modal-header" />
							</Box>
							<Box xcss={styles.content}>
								<Stack space="space.300">
									<Heading size="medium">
										<FormattedMessage id="townsquare.post-office.rovo-home-modal.title" description="Title for the Rovo appification modal informing users that Atlassian Home has been upgraded to the Rovo Home app" defaultMessage="Atlassian Home is now Rovo Home" />
									</Heading>
									<Box xcss={styles.bodyText}>
										<FormattedMessage id="townsquare.post-office.rovo-home-modal.body-paragraph-1" description="First paragraph explaining the Rovo Home app upgrade from Home" defaultMessage="We've upgraded your Home to Rovo Home, a faster way to find information and take action." />
									</Box>
									<Box xcss={styles.bodyText}>
										<FormattedMessage id="townsquare.post-office.rovo-appification-modal.body-paragraph-2" description="Second paragraph explaining the features available in the Rovo app" defaultMessage="You can now easily access Search, Chat and Agents alongside your familiar starred items, recent work and notifications - all in one place." />
									</Box>
								</Stack>
							</Box>
							<Box xcss={styles.footer}>
								<Button testId="rovo-appification-modal-continue" appearance="primary" onClick={onClose}>
									<FormattedMessage id="townsquare.post-office.rovo-appification-modal.continue-button" description="Continue button label for the Rovo appification modal" defaultMessage="Continue" />
								</Button>
							</Box>
						</Box>
						<Hide below="sm">
							<Box xcss={styles.rightHalf}>
								<Box xcss={styles.illustration}>
									<Image src={illustrationLight} srcDark={illustrationDark} alt="" testId="rovo-appification-modal-illustration" />
								</Box>
							</Box>
						</Hide>
					</Box>
				</Modal>}
		</ModalTransition>;
}
export default function RovoAppificationChangeboarding(): React.JSX.Element | null {
  const {
    rovoAppificationState
  } = useRovoAppification();
  if (rovoAppificationState === 'enabled') {
    return <HomeScreenSpaceFlagsChangeBoarding featureId="rovo-appification-modal">
				{({
        onDismiss
      }) => <RovoAppificationModal dismiss={onDismiss} />}
			</HomeScreenSpaceFlagsChangeBoarding>;
  }
  return null;
}